import { isInterval } from '../../../hooks/useActivityDetail';

import { computed } from 'vue';
import { curActivityDetail, isProgram } from '../../../hooks/useActivityDetail';
import { newLapListType } from './useLapSelectValue';

const sportType = computed(() => curActivityDetail.value?.summary?.sportType);

// 新版本圈数样式逻辑 2024年11月18日
export const isNewLapStyle = computed(() => {
  // 游泳特殊处理
  if ([300, 301].includes(sportType.value)) {
    return ![-1, 100000].includes(newLapListType.value);
  }
  return ![-1].includes(newLapListType.value) && (isProgram.value || isInterval.value);
});
